import { HttpInterceptorFn } from "@angular/common/http";

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
    const token = localStorage.getItem("token");
    if (token && !request.url.includes('/session/refresh')) {
        request = request.clone({
            setHeaders: { "x-auth-session": token },
        });
    }
    return next(request);
};
